<!-- 角色中心首页 -->
<template>
  <div class="jurisdiction">
    <div class="container">
      <el-card>
        <el-button
          v-has-permission="'/admin_role/v1/add'"
          class="colortheme"
          @click="
            dialogVisible.role = true
            dialogType = 0
          "
          >+添加角色</el-button
        >
        <el-button @click="refresh" class="refresh">刷新</el-button>
        <el-table
          :data="tabaleData"
          style="margin-top: 16px"
          row-key="id"
          lazy
          :header-cell-style="cellStyle"
        >
          <el-table-column prop="id" label="ID" width="100" align="center" />
          <el-table-column prop="roleName" label="角色名" align="center" />
          <el-table-column prop="description" label="角色描述" align="center" />
          <el-table-column prop="count" label="用户数量" align="center" />
          <el-table-column class="operation" width="120" label="操作" align="center">
            <template v-slot="{ row }">
              <div class="operation_bottom">
                <dic-button
                  permission="/admin_role/v1/detail"
                  @buttonClick="permissionItem(row)"
                  icon="icon-jr-icon-pen"
                  text="分配权限"
                />
                <dic-button
                  permission="/admin_role/v1/edit"
                  @buttonClick="editItem(row)"
                  icon="icon-jr-icon-modify"
                  text="编辑"
                />
                <dic-button
                  permission="/admin_role/v1/delete"
                  @buttonClick="deleteItem(row)"
                  icon="icon-jr-icon-delete"
                  text="删除"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="dialogType ? `编辑${authDescription}` : '新增角色'"
      :visible.sync="dialogVisible.role"
      width="40%"
      @close="handleClose"
      center
    >
      <el-form
        ref="roleObj"
        :model="roleObj"
        :rules="roleRules"
        label-width="80px"
        class="common_from"
      >
        <el-form-item label="角色名：" prop="roleName">
          <el-input v-model="roleObj.roleName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="roleObj.description"
            placeholder="请输入"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>
      </el-form>
      <div style="margin-top: 20px">权限修改之后，重新登录才失效</div>
      <div slot="footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="dialogVisible.role = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`分配${authDescription}权限`"
      :visible.sync="dialogVisible.auth"
      width="30%"
      @close="handleCloseAuth"
      center
    >
      <el-tree
        ref="tree"
        :data="menuListData"
        :props="defaultProps"
        @check="currentChecked"
        show-checkbox
        node-key="id"
        :default-checked-keys="roleObj.currentNode"
        :default-expanded-keys="roleObj.currentKey"
      ></el-tree>
      <div slot="footer">
        <el-button type="primary" @click="submitFormAuth">确 定</el-button>
        <el-button @click="dialogVisible.auth = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pagination } from '@/mixins/pagination'
import {
  autoRoleList,
  editRole,
  addRole,
  singleRole,
  deleteRole,
  editCount
} from '@/api/jurisdiction.js'
import { muList } from '@/api/menuManagement.js'
import DicButton from '../../../components/DicButton.vue'
const defaultRoleObj = Object.freeze({
  roleName: '', // 角色名
  description: '', // 备注
  authIdList: [],
  userName: '',
  createId: '',
  createTime: '',
  id: '',
  currentKey: [], // 选中key
  currentNode: [] // 选中node
})
export default {
  components: { DicButton },
  name: 'jurisdiction',
  mixins: [pagination],
  data() {
    return {
      selected: {
        node: [],
        expanded: []
      },
      authDescription: '', //编辑角色名字
      defaultProps: {
        children: 'children',
        label: 'authName'
      },
      dialogType: 0, // 新增
      dialogVisible: {
        role: false, // 角色弹窗
        auth: false // 权限弹窗
      },
      queryInfo: {
        pageNum: 0,
        pageSize: 30,
        roleName: '' //名字
      },
      menuListData: [], //菜单数据
      tabaleData: [], //表格数据
      roleObj: { ...defaultRoleObj },
      //表头样式
      cellStyle: {
        background: '#F7FAF8',
        color: '#1A1F33'
      },
      roleRules: {
        roleName: [{ required: true, message: '请输入角色', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.search()
  },
  methods: {
    //更新权限确定
    async submitFormAuth() {
      this.roleObj.authIdList = [...new Set(this.roleObj.authIdList.concat(this.selected.node))]
      if (this.roleObj.authIdList.length == 0) {
        this.$message.warning('请选择权限')
      } else {
        const { data: res } = await editRole(this.roleObj)
        if (res.resultCode === 200) {
          this.$message.success('权限更新成功')

          this.dialogVisible.auth = false
        }
        this.search()
      }
    },
    //分配权限
    async permissionItem(row) {
      await this.searchRoleById(row.id)
      this.authDescription = row.roleName
      const { data: res } = await muList()
      if (res.resultCode === 200) {
        this.menuListData = res.data
      }
      this.$nextTick(() => {
        this.dialogVisible.auth = true
      })
    },
    //选择权限
    currentChecked(nodeObj, SelectedObj) {
      const parentIdList = SelectedObj.checkedNodes.map((item) => {
        return item.parentId
      })
      const newParentIdList = parentIdList.filter(
        (itm, index, self) => self.indexOf(itm) === index && itm != 0
      )
      this.selected.node = [
        ...new Set([...SelectedObj.checkedKeys, ...newParentIdList, ...SelectedObj.halfCheckedKeys])
      ]
      this.selected.expanded = SelectedObj.halfCheckedKeys
    },
    //获取表格数据
    async search() {
      const { data: res } = await autoRoleList(this.queryInfo)
      if (res.resultCode === 200) {
        this.tabaleData = res.data.list
        this.total = res.data.total
      }
    },
    //编辑新增确定按钮
    submitForm() {
      this.$refs.roleObj.validate(async (valid) => {
        if (valid) {
          let res
          if (this.dialogType) {
            res = await editCount(this.roleObj)
          } else {
            res = await addRole(this.roleObj)
          }
          if (res.data.resultCode === 200) {
            this.$message.success(`${this.dialogType ? '编辑' : '新增'}成功`)
            this.dialogVisible.role = false
            this.search()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    //封装
    async searchRoleById(id) {
      this.roleObj.currentKey = []
      this.roleObj.currentNode = []
      const { data: res } = await singleRole({ id })
      if (res.resultCode === 200) {
        Object.assign(this.roleObj, res.data)
        this.roleObj.auths.forEach((item) => {
          this.roleObj.currentKey.push(item.id)
          if (item.children.length == 0) {
            this.roleObj.currentNode.push(item.id)
          }
          if (item.children.length > 0) {
            item.children.forEach((el) => {
              this.roleObj.currentKey.push(item.id)
              if (item.children.length == 0) {
                this.roleObj.currentNode.push(el.id)
              }
              if (el.children.length > 0) {
                el.children.forEach((il) => {
                  this.roleObj.currentKey.push(il.id)
                  this.roleObj.currentNode.push(il.id)
                })
              }
            })
          }
        })

        console.log(this.roleObj, 'this.roleObj')
      }
    },
    //编辑角色
    editItem(row) {
      this.searchRoleById(row.id)

      this.dialogType = 1

      this.dialogVisible.role = true
    },
    //删除角色
    deleteItem(row) {
      this.$confirm(`确认删除角色${row.roleName}吗 ?`, '提示')
        .then(async () => {
          const { data: res } = await deleteRole({ id: row.id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //刷新
    refresh() {
      this.tabaleData = []
      setTimeout(() => {
        this.search()
      }, 200)
    },
    // 弹窗关闭
    handleClose() {
      this.$refs.roleObj.resetFields()
      Object.assign(this.roleObj, defaultRoleObj)
      this.dialogVisible.role = false
    },
    handleCloseAuth() {
      Object.assign(this.roleObj, defaultRoleObj)

      this.selected.node = []

      this.selected.expanded = []

      this.dialogVisible.auth = false
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 80vh;
  overflow: scroll;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
.jurisdiction {
  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }
  /deep/ .refresh {
    color: #17757a;
    border: 1px solid #17757a;
  }

  /deep/ .refresh:hover {
    background-color: #fff;
  }

  /deep/ .colortheme {
    background-color: #17757a;
    color: #fff;
    border: 1px solid #17757a;
  }
}
</style>
